import { useEffect, useState } from "react";
import Mode from "../components/styles/Mode";
import { useDispatch } from "react-redux";
import Spacebox from "../components/Spacebox";
import { Typography } from "@mui/material";
import Grid from "../components/Grid";
import '../css/turboform.css'
import { isValidEmail, isValidUSPhoneNumber } from "../utilities/utils";
import requests from "../handlers/requests";
import cookies from "../utilities/Cookies";
import { updatedarkmode } from "../features/mode";


const ADRTestForm = () => {
    const dispatch = useDispatch()

    const states = ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'FL', 'GA', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'MI', 'MO', 'MS', 'NC', 'NE', 'NM', 'NV', 'NY', 'OH', 'OK', 'PA', 'SC', 'SD', 'TX', 'TN', 'UT', 'WV']

    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')

    const [amount, setAmount] = useState(25000)
    const [state, setState] = useState(states[0])
    const [city, setCity] = useState('')
    const [day, setDay] = useState('')
    const [zipcode, setZipcode] = useState('')
    const [month, setMonth] = useState('')
    const [year, setYear] = useState('')

    const [maxYear,] = useState((new Date()).getFullYear() - 18)


    const [error, setError] = useState(null)
    const [severity, setSeverity] = useState('error')

    const [isLoading, setIsLoading] = useState(false)

    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 })

    const handleChange = (event, setState) => {
        setState(event.target.value)
    }

    const handleBlur = (state, setState, max) => {
        const value = state
        if (!isNaN(parseFloat(value))) {
            let num = parseFloat(value)
            if (max >= num) {
                if (num > 0 && num < 10)
                    setState(`0${num}`)
                else
                    setState(`${num}`)
            } else {
                setState('')
            }
        }
    };

    const saveOrUpdateUser = () => {
        if (isValidEmail(email)) {
            if (isValidUSPhoneNumber(phone)) {
                if (firstName !== '' && lastName !== '') {
                    if (city !== '' && zipcode !== '' && year !== '' && month !== '' && day !== '') {
                        setIsLoading(true)
                        sendToADR()
                    } else {
                        setError('Empty fields not accepted')
                        scrollToTop()
                    }
                } else {
                    setError('Invalid Name')
                    scrollToTop()
                }
            } else {
                setError('Invalid Phone number')
                scrollToTop()
            }
        } else {
            setError('Invalid Email address')
            scrollToTop()
        }
    }

    const sendToADR = () => {
        const body = {
            first_name: firstName,
            last_name: lastName,
            email, phone, city, zipcode, state, debt_amount: amount, dob: `${year}-${month}-${day}`,
        }
        requests.post(`/api/adr/test`, body, () => { }, () => { }, () => { }, setIsLoading,
            (res) => {
                setSeverity('success')
                setError('Request was successful, redirect Url: ' + res.url)
                scrollToTop()
            },
            null,
            (res) => {
                if (res.msg.includes('ERR_BAD_REQUEST'))
                    setError('Request failed with status code 403')
                else
                    setError(res.msg.substring(0, 20))
                scrollToTop()
            }
        )
    }

    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="turbo-form-page" style={{ padding: '0px 20px' }}>
                <Spacebox padding="10px" />
                {(
                    <div className="margin-auto mid " style={{ boxShadow: '0px 0px 20px #00000030' }}>
                        <div className="survey-copy">
                            <div className="margin-auto" style={{ padding: '40px' }}>
                                <span style={{ fontWeight: '700', fontSize: 25, textAlign: 'left' }} className="text-primary heading bold hide-on-med-and-down">
                                    Test Form For ADR
                                </span>
                                <span style={{ fontWeight: '700', fontSize: 22, textAlign: 'left' }} className="text-primary heading bold hide-on-large-only">
                                    Test Form For ADR
                                </span>
                                <Spacebox padding="10px" />
                                <span style={{ fontSize: 14 }}>
                                    <i style={{ opacity: .6 }}>
                                        <b className="bold open-sans">Kindly use valid information as fake info will not work.</b>
                                    </i>
                                </span>
                                <Spacebox padding="10px" />
                                {/* Error message */}
                                {error && <div>
                                    {severity === 'error' && <div style={{ background: 'rgba(255, 0, 0, 0.05)', padding: '10px', textAlign: 'center' }}>
                                        <small>
                                            <b className="trade-red">{error}</b>
                                        </small>
                                    </div>}
                                    {severity === 'success' && <div style={{ background: 'rgba(0, 255, 68, 0.05)', padding: '10px', textAlign: 'center' }}>
                                        <small>
                                            <b className="trade-green">{error}</b>
                                        </small>
                                    </div>}
                                    <Spacebox padding="10px" />
                                </div>}
                                <div>
                                    <div>
                                        <Typography style={{ textAlign: 'center', fontSize: '14px' }}>
                                            <b className="open-sans">Select your debt amount balance</b>
                                        </Typography>
                                        <Spacebox padding="5px" />
                                        <Typography className="bold text-primary" variant="h3" style={{ textAlign: 'center', fontSize: '60px' }}>
                                            ${(amount).toLocaleString()}
                                        </Typography>
                                        <Spacebox padding="10px" />
                                        <div className="slidecontainer">
                                            <input
                                                type="range"
                                                min="20000"
                                                max="200000"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.valueAsNumber)}
                                                className="slider"
                                                step={1000}
                                                name="no-name"
                                            />
                                        </div>
                                    </div>
                                    <Spacebox padding="10px" />
                                </div>
                                <Grid grid={2} gap='10px'>
                                    <div>
                                        <small style={{ fontSize: 14 }} className="open-sans"><b>First Name</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            placeholder={"First Name"}
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <small style={{ fontSize: 14 }} className="open-sans"><b>Last Name</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            placeholder="Last Name"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Spacebox padding="10px" />
                                <div>
                                    <small style={{ fontSize: 14 }} className="open-sans"><b>Email</b></small>
                                    <Spacebox padding="2px" />
                                    <input
                                        type="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <Spacebox padding="10px" />
                                <div>
                                    <small style={{ fontSize: 14 }} className="open-sans"><b>Phone</b></small>
                                    <Spacebox padding="2px" />
                                    <input
                                        type="tel"
                                        placeholder="Phone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>
                                <Spacebox padding="10px" />
                                <div style={{ width: '50%' }}>
                                    <small style={{ fontSize: 14 }} className="open-sans"><b>Date of Birth</b></small>
                                    <Spacebox padding="2px" />
                                    <Grid grid={4} gap="10px">
                                        <div>
                                            <input
                                                type="text"
                                                value={month}
                                                onChange={(e) => handleChange(e, setMonth)}
                                                onBlur={() => handleBlur(month, setMonth, 12)}
                                                inputMode="numeric"
                                                placeholder="01"
                                                maxLength={2}
                                                pattern="[0-9]{1,2}"
                                                style={{ textAlign: 'center' }}
                                            />
                                            <Spacebox padding="2px" />
                                            <div style={{ textAlign: 'center' }}>
                                                <small className="open-sans">Month (MM)</small>
                                            </div>
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                value={day}
                                                onChange={(e) => handleChange(e, setDay)}
                                                onBlur={() => handleBlur(day, setDay, 31)}
                                                inputMode="numeric"
                                                placeholder="01"
                                                maxLength={2}
                                                pattern="[0-9]{1,2}"
                                                style={{ textAlign: 'center' }}
                                            />
                                            <Spacebox padding="2px" />
                                            <div style={{ textAlign: 'center' }}>
                                                <small className="open-sans">Day (DD)</small>
                                            </div>
                                        </div>
                                        <div style={{ gridColumn: '3/5' }}>
                                            <input
                                                type="text"
                                                value={year}
                                                onChange={(e) => handleChange(e, setYear)}
                                                onBlur={() => handleBlur(year, setYear, maxYear)}
                                                inputMode="numeric"
                                                placeholder="1979"
                                                maxLength={4}
                                                pattern="[0-9]{1,4}"
                                                style={{ textAlign: 'center' }}
                                            />
                                            <Spacebox padding="2px" />
                                            <div style={{ textAlign: 'center' }}>
                                                <small className="open-sans">Year <br /> (YYYY)</small>
                                            </div>
                                        </div>
                                    </Grid>
                                </div>
                                <Spacebox padding="10px" />
                                <div>
                                    <small style={{ fontSize: 14 }} className="open-sans"><b>State of Residence</b></small>
                                    <Spacebox padding="2px" />
                                    <select
                                        value={state}
                                        onChange={(e) => setState(e.target.value)}
                                        name="no-name"
                                    >
                                        {(states).map((st, i) => (
                                            <option key={i} value={st}>{st}</option>
                                        ))}
                                    </select>
                                </div>
                                <Spacebox padding="10px" />
                                <Grid grid={2} gap='10px'>
                                    <div>
                                        <small style={{ fontSize: 14 }} className="open-sans"><b>City</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            value={city}
                                            onChange={(e) => handleChange(e, setCity)}
                                        />
                                    </div>
                                    <div>
                                        <small style={{ fontSize: 14 }} className="open-sans"><b>Zip Code</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            value={zipcode}
                                            onChange={(e) => handleChange(e, setZipcode)}
                                            onBlur={() => handleBlur(zipcode, setZipcode, 99999)}
                                            inputMode="numeric"
                                            pattern="[0-9]{1,4}"
                                            style={{ textAlign: 'center' }}
                                        />
                                    </div>
                                </Grid>
                                <Spacebox padding="10px" />
                            </div>
                        </div>
                        <div style={{ background: '#00359e', height: 50, display: 'flex', justifyContent: 'flex-end' }}>
                            <div onClick={saveOrUpdateUser} style={{ background: 'rgb(255, 161, 0)', padding: '17px 24px', cursor: 'pointer' }}>
                                <span style={{ fontSize: 15 }} className="text-white">
                                    {!isLoading && "SUBMIT"}
                                    {isLoading && "PLEASE WAIT..."}
                                </span>
                            </div>
                        </div>
                    </div>
                )}
                <Spacebox padding="10px" />
            </div>
        </Mode >
    );
}

export default ADRTestForm;